// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"data-table_tooltipContent__2y9CP"};